export default __webpack_public_path__ + "static/media/2_0132.82073d3c.webp";